import { render, staticRenderFns } from "./addRemittance.vue?vue&type=template&id=adf27364&scoped=true&"
import script from "./addRemittance.vue?vue&type=script&lang=js&"
export * from "./addRemittance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf27364",
  null
  
)

export default component.exports